import type { FC } from 'react'

import { ComingSoonPage } from 'components'

const Partners: FC = () => <ComingSoonPage image={`${process.env.PUBLIC_URL}/partners.png`} title='partners' />

export default Partners
